export function normalize(s: string): string {
  return s.trim().toLowerCase();
}

export function byPrefix(text: string, prefix: string): boolean {
  if (!prefix) { return true; }

  return normalize(text).startsWith(normalize(prefix));
}
